<agr-page [pageTitle]="pageTitle()">
  <agr-form
    [formGroup]="form"
    class="layout--padding-bottom flex--gutter-container"
    style="padding-bottom: 0"
  >
    <div class="flex--row flex--align-center">
      <mat-form-field appearance="outline" class="labresult__search-input">
        <input
          matInput
          formControlName="search"
          placeholder="{{ 'labResults_searchLabResults' | translate }}"
          (keydown.escape)="clearSearchbox()"
          (keydown.enter)="searchLabresults(true)"
          [(ngModel)]="keyword"
        />

        <button mat-icon-button matSuffix (click)="clearSearchbox()" type="button">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
      <div class="spacing--margin-bottom spacing--margin-left">
        <button
          mat-flat-button
          matSuffix
          (click)="searchLabresults(true)"
          color="primary"
          type="submit"
        >
          <mat-icon>search</mat-icon>
          {{ 'labResults_searchLabResultsButton' | translate }}
        </button>
      </div>
    </div>
  </agr-form>

  <div [hidden]="dataSource.data.length === 0">
    <h2 class="text--h2 text--bold">{{ 'labresults' | translate }}</h2>

    <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" matSortDirection="desc">
      <ng-container matColumnDef="labResultId">
        <mat-header-cell *matHeaderCellDef>{{
          'labResults_labResultId' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.labResultId }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef>{{
          'labResults_description' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.description }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="labId">
        <mat-header-cell *matHeaderCellDef>{{ 'labResults_labId' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.labId }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{
          'labResults_updated' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.updated | date: 'medium' : locale }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="statusDescription">
        <mat-header-cell *matHeaderCellDef>{{
          'labResults_statusDescription' | translate
        }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.statusDescription | translate }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="reason">
        <mat-header-cell *matHeaderCellDef>{{ 'labResults_reason' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.reason }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumnLabResultTable"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumnLabResultTable"></mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [pageSize]="defaultPageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="onPage($event)"
      [length]="totalNumberOfItems()"
    ></mat-paginator>
  </div>
</agr-page>
